import type { WorkSheet } from 'xlsx';

/**
 * O Excel EXIBE numero grande em notacao cientifica ("3.21913E+13"), e o
 * sheet_to_json com raw:false entrega o texto exibido, nao o valor. Sem esta
 * correcao o CNPJ 32191284000137 chega no CRM como 32191300000000 — uma empresa
 * que nao existe, que contamina leads_carteira e clientes de uma vez so.
 *
 * Foi assim que 1.881 leads TT entraram com CNPJ falso ate 31/07/2026.
 *
 * Aqui devolvemos o numero por extenso para toda celula numerica inteira grande.
 * O corte em 1e11 e' de proposito: CNPJ (14 digitos) fica sempre acima; CPF
 * (11 digitos, max 9,9e10) e telefone com DDD ficam sempre abaixo e nao sao
 * tocados — o Excel ja os exibe por extenso. Data tambem nao entra: e' numerica,
 * mas o serial fica na casa dos 40 mil.
 *
 * Chamar SEMPRE antes de sheet_to_json com raw:false em planilha que tenha CNPJ.
 */
export function corrigirNotacaoCientifica(worksheet: WorkSheet): void {
  for (const endereco of Object.keys(worksheet)) {
    if (endereco.startsWith('!')) continue;
    const celula = (worksheet as Record<string, { t?: string; v?: unknown; w?: string; z?: string }>)[endereco];
    if (!celula || celula.t !== 'n' || typeof celula.v !== 'number') continue;
    if (!Number.isInteger(celula.v) || Math.abs(celula.v) < 1e11) continue;
    celula.w = String(celula.v);
    celula.z = '0';
  }
}
